import { ParticipantType, TransferType } from './calls';

/**
 * Transfer event names matching backend CallTransferEventName enum
 */
export enum CallTransferEventName {
  TransferInitiated = 'transfer-initiated',
  TransferRinging = 'transfer-ringing',
  TransferAnswered = 'transfer-answered',
  TransferCompleted = 'transfer-completed',
  TransferFailed = 'transfer-failed',
  TransferCanceled = 'transfer-canceled',
  TransferNoAnswer = 'transfer-no-answer',
  TransferBusy = 'transfer-busy',
}

/**
 * Communication Center event names
 */
export enum CommunicationCenterEventName {
  IncomingVoicemail = 'incoming-voicemail',
  IncomingSms = 'incoming-sms',
  AgentStatusChanged = 'agent-status-changed',
}

/**
 * Transfer status type matching backend TransferStatus
 */
export type TransferStatus =
  | 'initiated'
  | 'ringing'
  | 'answered'
  | 'completed'
  | 'failed'
  | 'canceled'
  | 'no-answer'
  | 'busy';

/**
 * Transfer event payload from backend
 */
export interface TransferEventPayload {
  transferCallLogId: number;
  conferenceId: number;
  conferenceSid: string;
  transferType: TransferType;
  status: TransferStatus;
  initiatingAgent: {
    id: number;
    coreProviderId: number;
    name: string;
  };
  targetAgent: {
    id: number;
    coreProviderId: number;
    name: string;
  };
  participantCallSid?: string;
  timestamp: string; // Date as ISO string
  reason?: string;
  metadata?: Record<string, any>;
}

/**
 * Participant event names matching backend ParticipantEventName enum
 */
export enum ParticipantEventName {
  ParticipantJoined = 'participant-joined',
  ParticipantLeft = 'participant-left',
  ParticipantHeld = 'participant-held',
  ParticipantUnheld = 'participant-unheld',
  ParticipantMuted = 'participant-muted',
  ParticipantUnmuted = 'participant-unmuted',
  ConferenceEnded = 'conference-ended',
}

/**
 * Participant event payload from backend
 */
export interface ParticipantEventPayload {
  conferenceId: number;
  conferenceSid: string;
  participantCallSid: string;
  participantType: ParticipantType;
  coreProviderId?: number;
  coreMemberId?: number;
  phoneNumber?: string;
  eventType: ParticipantEventName;
  timestamp: string;
  metadata?: {
    agentName?: string;
    duration?: number;
    reason?: string;
  };
}

export interface VoicemailEventPayload {
  callLogId: number;
  duration: number;
  fromNumber: string;
  toNumber: string;
  fromName?: string;
  toName?: string;
  direction: string;
  createdAt: string;
}

export interface SmsEventPayload {
  fromNumber: string;
  toNumber: string;
}

/**
 * Agent status change event payload from backend
 * Used to update the agent directory in real-time when any agent's status changes
 */
export interface AgentStatusEventPayload {
  agentId: number;
  coreProviderId: number;
  name: string;
  previousStatus: string;
  newStatus: string;
  timestamp: string;
}
